import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const SliderWrapper = styled.div`
    width: 100%;
    padding-top:${props => props.$arrayLength ? (props.$arrayLength*(props.$labelIsArray ? (props.$viewMode ? 3.7 : 4.5) :  (props.$viewMode ? 2.5 : 3.5) ))+1.5+'rem' : '0rem'};
    position:relative;
    margin-bottom:1rem;
    &>input{
    
        position: absolute; 
        margin: 0 !important;
        width: 100% !important;
        ::-webkit-slider-thumb {
            pointer-events: all !important;
            position: relative !important;
            z-index: 1 !important;
            outline: 0 !important;
        }
        -webkit-appearance: none;
        height: 1px;
        background: var(--lighter-gray);
        ::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            ${props => props.$viewMode ? `
                width : 0;
                cursor : default;
                `:`
                width : 0.8rem;
                cursor : pointer;
            `}
            
            height: 1.4rem;
            border-radius: 0.2rem; 
            border:solid var(--main-color) 1px;
            background: var(--bg);
            
        }
    }
`;
// width: ${props => props.$viewMode ? "0" :"0.8rem"};
// top: props.$index*(props.$labelIsArray?3.7:2.5)+'rem'
// cursor: ${props => props.$viewMode ? "default" :"pointer"};
const SectionLabel = styled.div.attrs(props => ({
        style: 
        {
            left: props.$percentage <= 50 ? `${props.$percentage}%` :'',
            right:props.$percentage > 50 ? `${100-props.$percentage}%` :'',
            transform: props.$percentage <= 50 ? `translateX(-${props.$percentage}%)` : `translateX(${100-props.$percentage}%)`, 
            top: !props.$viewMode ? (props.$index*(props.$labelIsArray?4.2:3.7))+'rem' : props.$index*(props.$labelIsArray?3.7:2.5)+'rem'
        },}))
    `
    position:absolute;
    text-align:center;
    font-size:0.9rem;
    color:var(--light-gray);
    font-weight:600;
    &>span{
        font-weight:800;
    }
`;
// font-family:var(--main-font-family);
// width:100%;
// font-size:1.0rem;
// font-weight:600;
// padding:0.7rem;
// color:var(--dark-gray);
// border:none;

// 
// 

const PortionEditor = styled.input`
    padding:0.2rem 0.4rem;
    margin-top:0.3rem;
    width: 4.5rem;
    font-weight:600;
    font-family:var(--main-font-family);
    border:none;
    color:var(--gray);
    box-shadow: var(--button-outline);
    -moz-box-shadow: var(--button-outline);
    -webkit-box-shadow: var(--button-outline);
    transition:0.08s;
    border-radius:0.4rem;
    background: var(--bg);
    &:focus  {
        outline: rgba(48, 192, 140, 0.5) solid 0.25rem !important;
    }
`
function generateLabelByWeeks (weekRawData){
    if(weekRawData.weekStartDate){
        const startDate = new Date(weekRawData.weekStartDate+"T00:00");
        const newDate = new Date(startDate);
        newDate.setDate(startDate.getDate() + 6);
        return startDate.toLocaleDateString("en-US",{ day: 'numeric', month: 'numeric' })+"-"+newDate.toLocaleDateString("en-US",{ day: 'numeric', month: 'numeric' });
    }
    return "Unknown week"
}

function generateLabelByTrucks (trucksRawData){
    let driversNames = "Unknown Driver";
    if(trucksRawData.firstDriverFirstName){
        driversNames = trucksRawData.firstDriverFirstName + " " + trucksRawData.firstDriverLastName;
    }
    if(trucksRawData.secondDriverFirstName){
        if(driversNames === "Unknown Driver"){
            driversNames = trucksRawData.secondDriverFirstName + " " + trucksRawData.secondLastName;
        }else{
            driversNames = driversNames.replace(" " + trucksRawData.firstDriverLastName, "/"+trucksRawData.secondDriverFirstName);
        }
    }
    return ["#"+trucksRawData['truckNumber'], `(${driversNames})`]
}
function changePrevSplitValue(array, currentIndex, remeinder, amountForInvoice){
    if(currentIndex < 0){
        return null;
    }else{
        
        const prevVal = array[currentIndex-1].value;
        if(prevVal >= remeinder){
            const newVal = prevVal - remeinder;
            array[currentIndex-1] = {
                perc: (newVal/1300)*100,
                value: newVal
            };
            return array;
        }else{
            array[currentIndex-1] = {
                value: 0,
                perc: 0
            };
            return changePrevSplitValue(array, currentIndex-1, remeinder - prevVal, amountForInvoice);
        }
    }
}
export const Splitter = ({viewMode, data, amountForInvoice, splitBy}) => {
    const labelsArray = [];
    const valuesArray = [];
    const parsedData = data;
    let compoundedValue = 0;
    for(const [index, divisionData] of parsedData.entries()){
        labelsArray.push(splitBy === "weeks" ? generateLabelByWeeks(divisionData) : generateLabelByTrucks(divisionData));
        if(index !== parsedData.length-1){
            compoundedValue += divisionData.percentage || 0;
            const percentage = compoundedValue;
            valuesArray.push({
                perc: percentage*100,
                value: Math.round(amountForInvoice * percentage),
            })
        }
    }
    const [splitState, setSplitState] = useState(valuesArray);
    useEffect(() => {
        if(JSON.stringify(valuesArray)!==JSON.stringify(splitState)){
            setSplitState(valuesArray);
        }
        return () => {
        }
    // eslint-disable-next-line
    }, [data, amountForInvoice])
    
    const [selectedThumbIndex, setSelectedThumbIndex] = useState(null);
    const updateArray = (newVal, selectedIndex) => {
        const newValObj = {
            perc : newVal,
            value :  Math.round(amountForInvoice * (newVal/100))
        }
        const newArr = [...splitState];
        for(const [index, value] of newArr.entries()){
            if(newArr[selectedIndex].perc < newValObj.perc){
                //moving right
                if(selectedIndex < index && value.perc < newValObj.perc){
                    newArr[index]= newValObj;
                }
            }else{
                //moving left
                if(selectedIndex > index && value.perc > newValObj.perc){
                    newArr[index] = newValObj;;
                }
            }
        }
        newArr[selectedIndex] = newValObj;
        setSplitState(newArr);
    }
    const inputEvent = (e) => {
        const newVal = parseInt(e.target.value);
        let initIndex = null;
        if(selectedThumbIndex === null){
            const lastItemIndex = splitState.length-1;
            for (const [index, value] of splitState.entries()) {
                if(splitState[0].perc >= newVal){
                    initIndex = 0;
                    setSelectedThumbIndex(0);
                }else if(splitState[lastItemIndex].perc < newVal){
                    initIndex = lastItemIndex;
                    setSelectedThumbIndex(lastItemIndex);
                }else if(newVal <= value.perc){
                    const leftThumb = splitState[index-1].perc;
                    const rightThumb = splitState[index].perc;
                    const halfDiff = (rightThumb - leftThumb)/2;
                    if(leftThumb === rightThumb){
                    }else if(leftThumb+halfDiff > newVal){
                        initIndex = index-1;
                        setSelectedThumbIndex(index-1);
                    }else{
                        initIndex = index;
                        setSelectedThumbIndex(index);
                    }   
                    break;
                }
            }
        }
        if(selectedThumbIndex !== null){
            updateArray(newVal, selectedThumbIndex);
        }else if(initIndex !== null){
            updateArray(newVal, initIndex);
        }
    }
    const onMouseUp = () => {
        setSelectedThumbIndex(null);
    }
    const editDistributionVal = (e, index) => {
        let tagVal = e.target.value.replace(/\D/g, '');
        if(index === null || index === 0){
            if(index === null){
                index = splitState.length - 1;
                if(e.target.value === ""){
                    tagVal = 0;
                }else{
                    tagVal = splitState[index].value + ((amountForInvoice - splitState[index].value) - parseInt(tagVal));
                }
            }else{
                if(e.target.value === ""){
                    tagVal = 0;
                }else{
                    tagVal = parseInt(tagVal);
                }
            }
            if(tagVal >= 0 && tagVal <= amountForInvoice){
                updateArray((tagVal / amountForInvoice)*100, index)
            }
        }else{
            if(e.target.value === ""){
                tagVal = splitState[index-1].value;
            }else{
                tagVal = splitState[index-1].value + parseInt(tagVal);
            }
            if(tagVal > amountForInvoice){
                const reminder = tagVal - amountForInvoice; 
                let newArr = [...splitState];
                newArr = changePrevSplitValue(newArr, index, reminder, amountForInvoice);
                if(newArr !== null){
                    const newCurrentVal = amountForInvoice;
                    newArr[index] = {
                        perc:  (newCurrentVal/amountForInvoice) * 100,
                        value: newCurrentVal
                    }
                    
                    setSplitState(newArr)
                }
            }else{
                updateArray((tagVal / amountForInvoice)*100, index)
            }
        }
    }  
    return <SliderWrapper $arrayLength={splitState.length+1} $viewMode={viewMode} $labelIsArray={Array.isArray(labelsArray[0])} >
        {
            splitState.map((valObj, index)=>{
                const percentage = index === 0 ? valObj.perc/2 : (splitState[index].perc+splitState[index-1].perc)/2;
                const value = formatValue(index === 0 ? valObj.value : (splitState[index].value-splitState[index-1].value));
                return <SectionLabel key={index} $index={index} $viewMode={viewMode} $percentage={percentage} $labelIsArray={Array.isArray(labelsArray[index])} >
                    <DistributinLabel lbl={labelsArray[index]} />
                    <br /> 
                    { viewMode ?
                    <span>
                        {`$${value}`}
                    </span>
                    :
                    <span>
                        $ <PortionEditor value={value} onChange={(e)=>{
                            editDistributionVal(e, index);       
                        }} />
                    </span>
                    }
                </SectionLabel>
            })
        }
        
        <SectionLabel $index={splitState.length} $lastLabel={true} $viewMode={viewMode} $percentage={splitState[splitState.length-1].perc + (100-splitState[splitState.length-1].perc)/2} $labelIsArray={Array.isArray(labelsArray[0])} >
                <DistributinLabel lbl={labelsArray[splitState.length]}  />
                <br />
                {viewMode ?
                    <span>
                        {`$${formatValue(amountForInvoice - splitState[splitState.length-1].value)}`}
                    </span>
                    :
                    <span>
                        $ <PortionEditor value={formatValue(amountForInvoice - splitState[splitState.length-1].value)} onChange={(e)=>{
                            editDistributionVal(e, null);       
                        }} />
                    </span>
                }
               
            </SectionLabel>
        {
            splitState.map((val, index)=>{
                return <input key={index} className={viewMode?"":"splittionSlider"} id={`splittionSlider`+index} type="range" min="0" max="100" value={val.perc} readOnly={viewMode} onChange={!viewMode?inputEvent:null} onMouseUp={!viewMode?onMouseUp:null} data-full-value={val.perc} />
            })
        }
    </SliderWrapper>
}
//<br /> (Driver Name)
const DistributinLabel = ({lbl}) =>{
    if(Array.isArray(lbl)){
        return<>{lbl[0]}<br />{lbl[1]}</>
    }else{
        return<>{lbl}</>
    }
}
function formatValue(value){
    return Number(value).toFixed(2).replace(/\.?0+$/, '');
}